export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fed726cdfa2a27860ab294b03d1b7174683c81021&name=fetchTypeahead!'